<template>
  <div>
    <v-card
      color="primary"
      dark
      class="mb-3"
    >
      <v-card-text class="d-flex align-center">
        <v-btn
          icon
          @click="onMenuBuscar"
          class="mr-2"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <div class="flex-grow-1">
          <div class="subtitle-2">
            <v-icon small left>mdi-card-account-details</v-icon>
            {{ cuenta.documento }} - <strong>{{ cuenta.razon_social }}</strong>
          </div>
          <div class="caption">
            <v-icon small left>mdi-credit-card</v-icon>
            {{ cuenta.numero }} {{ cuenta.descripcion }}
          </div>
          <div class="caption" v-if="cuenta.saldo_subsidio">
            <v-icon small left>mdi-cash</v-icon>
            Saldo subsidio: $ {{ cuenta.saldo_subsidio | formatToTwoDecimals }}
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'

export default {
  name: 'CuentaDestinoSelectedComponent',
  components: {
    //
  },
  data () {
    return {
      loading: false,
      search: null,
    }
  },
  created () {
    //
  },
  computed: {
    ...mapGetters('Transferencias', ['cuenta']),
  },
  methods: {
    ...mapActions('Transferencias', ['onClearEdited', 'onClearCuenta']),
    onMenuUsuario (event) {
      event.preventDefault()
      this.$router.push({ name: 'clientes-form' })
    },
    onMenuBuscar (event) {
      event.preventDefault()
      this.onClearEdited()
      this.onClearCuenta()
      // alert('Elimina la cuenta seleccionada y deja disponible para busqueda nueva!')
    },
  },
}
</script>
